/* eslint-disable max-len */
import { ReactElement, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import NavigationPage from '../../components/NavigationPage/NavigationPage';
import AnnouncementCard from '../../components/AnnouncementCard/AnnouncementCard';
import { fetchAnnouncementsByDocumentType } from 'src/redux/thunks/announcementsThunks';
import './Announcements.css';
import { abortPromiseOnUnmount } from 'src/services/base.service';
import { selectAnnouncements } from '../../redux/slices/announcementSlice';
import { AnnouncementDataModel } from 'src/types/propTypes/AnnouncementDataModel';
import { groupHelpCenterPanels } from './AnnouncementsPanel';

const Announcements = (): ReactElement => {
  const dispatch = useAppDispatch();
  const announcementDataItems: AnnouncementDataModel[] = useAppSelector(
    selectAnnouncements  
  );
  const panels = groupHelpCenterPanels(announcementDataItems);

  useEffect(() => {
    const promise: unknown = dispatch(fetchAnnouncementsByDocumentType('Announcements'));
    return () => {
      abortPromiseOnUnmount(promise);
    };
  }, [dispatch]);

  useEffect(() => {
    console.log(groupHelpCenterPanels(announcementDataItems));
  }, [announcementDataItems]);

  return (
    <NavigationPage
      heading={'Announcements'}
      pageClass="announcements"
      isLoading={false}
    >
    <div className="announcements--directions">
      { announcementDataItems.length > 0 && panels.map((panel) => (
        <AnnouncementCard
          key={panel.panelTitle}
          panelTitle={panel.panelTitle}
          subpanels={panel.subPanels}
        />
      ))}
    </div>
    </NavigationPage>
  );
};

export default Announcements;
